import Layout from "@/components/Layout/Layout"
import { useAllGames } from "@/graphql/hooks/useGames"
import { useAuthContext } from "@/contexts/AuthContext"
import { HeroSection } from "@/components/home/HeroSection"
import { GamesSection } from "@/components/home/GamesSection"
import { ActiveTournamentsSection } from "@/components/home/ActiveTournamentsSection"
import { FeaturesSection } from "@/components/home/FeaturesSection"
import { CTASection } from "@/components/home/CTASection"

const Index = () => {
  const { games, loading, error } = useAllGames()
  const { isAuthenticated, person } = useAuthContext()

  return (
    <Layout>
      <div className="min-h-screen overflow-x-hidden">
        <HeroSection games={games} loading={loading} />
        <ActiveTournamentsSection personId={person?.id} />
        <GamesSection games={games} loading={loading} error={error} />
        <FeaturesSection />
        {!isAuthenticated && <CTASection />}
      </div>
    </Layout>
  )
}

export default Index
